import { render, staticRenderFns } from "./SensorList.vue?vue&type=template&id=2ddb5692&"
import script from "./SensorList.vue?vue&type=script&lang=js&"
export * from "./SensorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports